import { Button, Container, Grid, Typography } from '@mui/material';
import getStyles from './styles';
import { ArrowRight } from 'lucide-react';
import { Helmet } from 'react-helmet';

const FellowshipBanner = () => {
  const styles = getStyles();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <Helmet>
        <title>Fellowship | Amizhth Next-gen leaders fellowship</title>
        <meta
          name="title"
          content="Amizhth Next-Gen Leaders Fellowship | Leadership & Product Skills Program"
        />
        <meta
          name="description"
          content="Amizhth’s Next-Gen Leaders Fellowship helps students and early professionals develop leadership ability, product thinking, and real-world problem-solving skills through an immersive, challenge-based learning experience."
        />
        <meta
          name="keywords"
          content="Next-Gen Leaders Fellowship, leadership fellowship, fellowship for students, leadership development fellowship, youth leadership fellowship, leadership mindset, real-world exposure for students, project-based learning"
        />
      </Helmet>
      <Grid sx={styles.staticHero}>
        <Grid sx={styles.heroContainer} />
        <Grid sx={styles.heroInner}>
          <Container maxWidth={'xl'}>
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={12} md={6}>
                <Grid sx={styles.heroContent}>
                  {/* <Typography variant="span" sx={styles.badge}>
                    <Sparkles
                      style={{
                        width: '12px',
                        height: '12px',
                        marginRight: '4px'
                      }}
                    />
                    Applications Open Soon
                  </Typography> */}
                  <Typography variant="h1" sx={styles.slideTitleh1}>
                    Amizhth <span style={styles.textGradient}>Next-Gen</span>{' '}
                    Leaders Fellowship
                  </Typography>
                  <Typography sx={styles.slideTextp}>
                    An immersive journey for ambitious students and young
                    aspirants to become confident founders, leaders, and
                    real-world product builders.
                  </Typography>
                  <Grid sx={styles.buttonGroup}>
                    <Button
                      variant="contained"
                      size="large"
                      style={styles.themeBtn}
                      endIcon={
                        <ArrowRight
                          style={{
                            width: '20px',
                            height: '20px',
                            marginLeft: '8px'
                          }}
                        />
                      }
                      onClick={() => scrollToSection('apply')}
                    >
                      Join the Fellowship
                    </Button>
                    {/* <Button
                      variant="outlined"
                      size="large"
                      sx={styles.outlineBtn}
                      onClick={() => scrollToSection('structure')}
                    >
                      Know More
                    </Button> */}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6}>
                <Grid sx={styles.heroImageContainer}>
                  <Grid sx={styles.heroImageGlow} />
                  <img
                    src="/images/hero-fellowship.jpg"
                    alt="Young entrepreneurs collaborating on building products"
                    style={styles.heroImage}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Container>
          {/* <Grid sx={styles.scrollIndicator}>
          <Grid sx={styles.scrollCircle}>
            <Grid sx={styles.scrollDot} />
          </Grid>
        </Grid> */}
        </Grid>
      </Grid>
    </>
  );
};

export default FellowshipBanner;
